import { render, staticRenderFns } from "./flex-grid.vue?vue&type=template&id=b1bb84b0&scoped=true"
import script from "./flex-grid.vue?vue&type=script&lang=js"
export * from "./flex-grid.vue?vue&type=script&lang=js"
import style0 from "./flex-grid.vue?vue&type=style&index=0&id=b1bb84b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb84b0",
  null
  
)

export default component.exports